<app-dialog-structure
  [title]="data ? 'Edit Airline' : 'Add Airline'"
  [submitButton]="data ? 'SAVE' : 'ADD'"
  (cancel)="close()"
  (submit)="submitEmitter()"
  [disableAction]="airlineForm.invalid || isImporting || !contactsValiadtion()"
  >
  <div class="display-layout-column layout-gap-15">
    <div [formGroup]="airlineForm" class="display-layout-row layout-gap-10 layout-align-start">
      <div class="display-layout-column">
        <mat-form-field>
          <mat-label>Airline Name *</mat-label>
          <input matInput formControlName="airlineName" type="text" />
          @if (airlineForm.controls['airlineName'].hasError('required')) {
            <mat-error
              >
              Airline Name is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Abbreviation *</mat-label>
          <input matInput formControlName="abbreviation" type="text" />
          @if (airlineForm.controls['abbreviation'].hasError('required')) {
            <mat-error
              >
              Airline Abbreviation is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="display-layout-column">
        <mat-form-field>
          <mat-label>IATA Code *</mat-label>
          <input matInput formControlName="iata" type="text" />

          @if (
            airlineForm.controls['iata'].hasError('maxlength') ||
            airlineForm.controls['iata'].hasError('minlength')
            ) {
            <mat-error
              >
              IATA Code is <strong>3 characters</strong> long
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Airline Status</mat-label>
          <mat-select formControlName="status" required>
            @for (status of status; track status) {
              <mat-option [value]="status.value"
                >{{ status.viewValue }}
              </mat-option>
            }
          </mat-select>

          @if (airlineForm.controls['status'].hasError('required')) {
            <mat-error
              >
              Airline Status is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <input
      type="file"
      #file
      style="display: none"
      (change)="import()"
      multiple
      accept=".pdf, .xlsx"
      />
    <div class="display-layout-row layout-align-start align-items-center">
      <button  mat-stroked-button (click)="importERateSheet()" [disabled]="!airline">
        Import eRateSheet
      </button>

      @if (!airline) {
        <div class="display-layout-row layout-align-center-center">
          <mat-icon
            matTooltip="An eRateSheet can be imported once the Airline is created."
            >info_outline</mat-icon
            >
          </div>
        }
      </div>
      <!-- CONTACTS -->
      <mat-divider></mat-divider>
      <div class="display-layout-column layout-align-start">
        <div class="display-layout-row layout-gap-60">
          <div class="display-layout-column" [formGroup]="contactsForm">
            <mat-form-field>
              <mat-label>Contact Person</mat-label>
              <input
                matInput
                formControlName="contactName"
                type="text"
                required
                />
              @if (contactsForm.controls['contactName'].hasError('required')) {
                <mat-error
                  >
                  Name of the Contact Person is <strong>required</strong>
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field>
              <mat-label>Contact Mail</mat-label>
              <input
                matInput
                formControlName="contactMail"
                type="text"
                required
                />
              @if (contactsForm.controls['contactMail'].hasError('required')) {
                <mat-error
                  >
                  Email of the Contact Person is <strong>required</strong>
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field>
              <mat-label>Contact Phonenumber</mat-label>
              <input
                matInput
                formControlName="phoneNumber"
                type="text"
                required
                />
              @if (contactsForm.controls['phoneNumber'].hasError('required')) {
                <mat-error
                  >
                  Phonenumber of the Contact Person is
                  <strong>required</strong>
                </mat-error>
              }
            </mat-form-field>

            <button
              mat-button
              [disabled]="contactsForm.invalid"
              (click)="addContact()"
              >
              Add Contact
            </button>
          </div>


          <div >
            <table mat-table [dataSource]="contactsTableSource" >

              <ng-container matColumnDef="contactName">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.contactPerson }}
                </td>
              </ng-container>

              <ng-container matColumnDef="contactMail">
                <th mat-header-cell *matHeaderCellDef>Mail</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.contactMail }}
                </td>
              </ng-container>

              <ng-container matColumnDef="contactPhone">
                <th mat-header-cell *matHeaderCellDef>Phone</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.phoneNumber }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <button mat-icon-button (click)="deleteContact(i)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedContactColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedContactColumns"
              ></tr>
            </table>
            <mat-paginator
              [pageSizeOptions]="[5]"
              showFirstLastButtons
            ></mat-paginator>
            @if (!contactsValiadtion()) {
              <div class="warning">
                Please make sure that contacts are defined!
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </app-dialog-structure>
